import React, { useState } from "react";
import facebook from "../assets/icons/facebook.svg";
import instagram from "../assets/icons/instagram.svg";
import twitter from "../assets/icons/twitterNew.svg";
import linkedin from "../assets/icons/linkedin.svg";
import wallpaperflare from "../assets/Images/wallpaperflare 1.png";
import "./AboutBandhan.css";
import Bandhan_name_logo from "../assets/Images/Bandhan2.0-logo.svg";
import { NavLink, useNavigate } from "react-router-dom";
import "../LandingPage/Navbar.css";
const AboutBandhan = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const [iframe, setIframe] = useState(false);

  return (
    <>
      {!iframe ? (
        <div className="Bandhan-about-page-container">
          <header className="header">
            <div className="container">
              <img
                alt="logo"
                onClick={() => {
                  navigate("/");
                }}
                className="logo"
                src={Bandhan_name_logo}
              />

              <input className="menu-btn" type="checkbox" id="menu-btn" />
              <label className="menu-icon" htmlFor="menu-btn">
                <span className="navicon"></span>
              </label>
              <ul className="menu">
                <li>
                  <NavLink to="/helpfaqs" className="active">
                    Help & FAQs
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    onClick={() => {
                      handleTabChange(1);
                    }}
                    to="/aboutbandhan"
                    className={`tab ${activeTab === 1 ? "active" : ""}`}
                  >
                    About Bandhan
                  </NavLink>
                </li>

                <li>
                  <button
                    onClick={() => setIframe(true)}
                    className="start-now-buttons"
                  >
                    Start Now
                  </button>
                </li>
              </ul>
            </div>
          </header>

          <div className="about-bandhan-data-card">
            <div className="about-bandhan-card">
              <div className="left-side-cards">
                <div className="card1">
                  <h1 className="AboutBandhan-heading">
                    Welcome to Bandhan 2.0
                  </h1>
                  <h2 className="AboutBandhan-heading2">
                    A New Era in the Metaverse! 🚀
                  </h2>
                </div>
                <div className="card2">
                  <p className="AboutBandhan-paragraph">
                    Get ready to embark on an immersive journey like never
                    before! Bandhan 2.0 is our innovative virtual platform
                    designed to connect, engage, and empower you in a fully
                    interactive metaverse environment. In this space, you will
                    get a glimpse of what it's like to work with us, learn about
                    our industry, meet our leaders, and dive deep into key
                    resources that will equip you for success. Step into Bandhan
                    2.0 today and experience a whole new way of working,
                    collaborating, and growing together.
                  </p>
                </div>
              </div>

              <div className="right-side-container">
                <img className="flare-image" src={wallpaperflare} alt="logo" />
              </div>
            </div>
          </div>

          <div className="Bandhan-landing-page-logo-container">
            <a
              href="https://x.com/AxisMaxLifeIns"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="icons-alignment" src={twitter} alt="Twitter" />
            </a>

            <a
              href=" https://facebook.com/AxisMaxLife/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="icons-alignment" src={facebook} alt="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/axis_max_life_insurance/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="icons-alignment"
                src={instagram}
                alt="Instagram"
              />
            </a>

            <a
              href=" https://www.linkedin.com/company/axis-max-life-insurance-limited/"
              target="_blank"
              rel="noopener"
            >
              <img className="icons-alignment" src={linkedin} alt="LinkedIn" />
            </a>
          </div>
          <footer className="section bg-footer">
            <div className="footer-section-icons">
              <a
                href="https://x.com/AxisMaxLifeIns"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="footer-icons-alignment"
                  src={twitter}
                  alt="Twitter"
                />
              </a>

              <a
                href=" https://facebook.com/AxisMaxLife/"
                target="_blank"
                rel="noopener"
              >
                <img
                  className="footer-icons-alignment"
                  src={facebook}
                  alt="Facebook"
                />
              </a>
              <a
                href="https://www.instagram.com/axis_max_life_insurance/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="footer-icons-alignment"
                  src={instagram}
                  alt="Instagram"
                />
              </a>

              <a
                href=" https://www.linkedin.com/company/axis-max-life-insurance-limited/"
                target="_blank"
                rel="noopener"
              >
                <img
                  className="footer-icons-alignment"
                  src={linkedin}
                  alt="LinkedIn"
                />
              </a>
            </div>
          </footer>
        </div>
      ) : (
        <iframe
          title="Bandhan 2.0"
          width="100%"
          height="100%"
          id=""
          src="https://maxlife.gmetri.com/bandhan2"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; microphone; camera; display-capture; xr-spatial-tracking; xr;"
          frameborder="0"
          allowfullscreen
        ></iframe>
      )}
    </>
  );
};

export default AboutBandhan;
